export const SAME_ISSUE_DESCRIPTION = 'This customer also has the same issue as the ticket.';
